import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';

import { FormsUtilsService, MessageService } from '../../services';
import { BaseEntity } from '../../../models';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class BaseFormModalService {

    constructor(private formsUtilsService: FormsUtilsService,
                private messageService: MessageService) { }

    /** Prepara a entidade para ser editada */
    prepareEdit<T extends BaseEntity>(entityIndex: number, entities: T[]): T {
        // Realiza uma cópia da entidade para efetuar as alterações na cópia e não no objeto "real"
        return _.cloneDeep(entities[entityIndex]);
    }

    /** Save padrão das entidades  */
    save<T extends BaseEntity>(entity: T, entities: T[], form: NgForm, editMode: boolean, currentIndex: number, msgFormInvalid?: string): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            this.formsUtilsService.makeAllFieldsDirty(form);

            if (form.valid) {
                try {
                    if (!editMode) {
                        entities.push(entity)
                        resolve();
                    } else {
                        entities[currentIndex] = entity;
                        resolve();
                    }
                } catch (error) {
                    this.messageService.error('Ocorreu um erro ao salvar. Tente novamente', 'Erro', error);
                    reject();
                }
            } else {
                if (msgFormInvalid) {
                    this.messageService.info(msgFormInvalid, 'Informação');
                } else {
                    this.formsUtilsService.showMsgFormInvalid();
                }
                reject();
            }
        });
    }
}
